import {usePage} from '@inertiajs/react';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import PropTypes from 'prop-types';
import BrandLogo from '@/Fi16100/Components/BrandLogo';
import {useContext} from 'react';
import './Navigation.css';
import NavLink from '@/Fi16100/Components/NavLink';
import {I18nContext} from 'react-i18next';
import Link from '@/Fi16100/Components/Link';

function Navigation(props) {
	const t = useContext(I18nContext).i18n.t;
	const businessSiteOrigin = String(usePage().props.businessSiteOrigin);

	return (
		<Navbar variant="light" bg="light" expand="xl" className={(props.className ?? '') + ' text-dark'}>
			<Container>
				<Link href={route('fi16100.home')} className="navbar-brand">
					<BrandLogo />
				</Link>

				<Navbar.Toggle aria-controls="navbar-collapse" className="border-2" />

				<Navbar.Collapse id="navbar-collapse">
					<hr className="d-xl-none text-gray my-3" aria-hidden="true" />

					<Nav className="justify-content-center text-center align-items-xl-center flex-grow-1">
						<NavLink href={route('fi16100.home')} active={route().current('fi16100.home')}>
							{t('navigation.home')}
						</NavLink>

						<NavLink href={route('fi16100.sms')} active={route().current('fi16100.sms')}>
							{t('navigation.sms')}
						</NavLink>

						<NavLink href={route('fi16100.calls')} active={route().current('fi16100.calls')}>
							{t('navigation.calls')}
						</NavLink>

						<NavLink href={route('fi16100.vehicles')} active={route().current('fi16100.vehicles')}>
							{t('navigation.vehicles')}
						</NavLink>

						<NavLink href={route('fi16100.company')} active={route().current('fi16100.company')}>
							{t('navigation.company')}
						</NavLink>

						<NavLink external={true} href={businessSiteOrigin + '/'}>
							{t('navigation.businesses')}
						</NavLink>
					</Nav>

					<Nav className="text-center justify-content-end">
						<NavLink external={true} href="https://connect.16100.fi">
							{t('navigation.logIn')}
						</NavLink>
					</Nav>
				</Navbar.Collapse>
			</Container>
		</Navbar>
	);
}

Navigation.propTypes = {
	className: PropTypes.string
}

export default Navigation;
